import 'core-js';

import SignInModule from '../modules/signIn/signIn.module';

// If the variable is unused, it won't be imported, then the module won't work
SignInModule;
